// Port of webapp/src/components/topBar.tsx — the small utility row above the
// board title. Upstream links out to focalboard.com; the links are kept but
// point at the real product docs.

import {ReactElement} from 'react'
import {Constants} from '../../common/constants'
import {Icon} from '../common/icons'

type Props = {
    onSearch: () => void
}

export default function TopBar({onSearch}: Props): ReactElement {
    return (
        <div className='TopBar flex items-center justify-end gap-3 py-1 text-sm'>
            <button
                type='button'
                className='flex items-center gap-1 opacity-70 hover:opacity-100'
                onClick={onSearch}
            >
                <Icon name='search' size={14}/>
                <span>搜索</span>
                <kbd className='rounded border border-main-fg/20 px-1 text-xxs opacity-70'>支持快捷键</kbd>
            </button>
            <a
                className='opacity-70 hover:opacity-100'
                href={'https://www.focalboard.com/fwlink/feedback-focalboard.html?v=' + Constants.versionString}
                target='_blank'
                rel='noreferrer'
            >
                意见反馈
            </a>
            <a
                href='https://www.focalboard.com/guide/user?utm_source=webapp'
                target='_blank'
                rel='noreferrer'
                className='IconButton'
                aria-label='帮助'
            >
                <Icon name='help' size={16}/>
            </a>
        </div>
    )
}
